import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';

// ── Guard de autenticación ────────────────────────────────────────────────────
@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(): boolean {
    if (this.auth.isAuthenticated()) return true;
    this.router.navigate(['/login']);
    return false;
  }
}

// ── Guard de rol/acceso ───────────────────────────────────────────────────────
// Uso en rutas: canActivate: [AccesoGuard], data: { accesos: [100001] }
@Injectable({ providedIn: 'root' })
export class AccesoGuard implements CanActivate {
  constructor(private auth: AuthService, private router: Router) {}

  canActivate(route: ActivatedRouteSnapshot): boolean {
    const requeridos: number[] = route.data['accesos'] ?? [];
    if (requeridos.length === 0) return true;

    const ok = requeridos.some(c => this.auth.hasAcceso(c));
    if (!ok) this.router.navigate(['/app/inicio']);
    return ok;
  }
}
